import { Reducers } from '@sda/enums/store';
import { PrivateInvitationMask } from '@sda/sdk/masks';
import { SDK } from './helpers/sdk';
import type { FirestoreClientData } from './interfaces';
import type { Invitation } from '@sda/interfaces/invitation';

/**
 * SDK Class to interact with Firestore Invitations.
 */
export class Invitations extends SDK<Invitation> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.INVITATIONS);

    this.collection = this.fsh.Schema.PrivateInvitations;

    this.PrivateMap = PrivateInvitationMask;
  }
}
